export default {
  GET_SELECT_MEMBER:(state)=>{
      return state.selectMember
  },
  GET_RESULT:(state)=>{
      return state.Result
  },
  GET_EDIT_MEMBER:(state)=>{
      return state.editMember
  },
}